import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState, useRef } from "react";
import Eases from "eases";

function useInterval(callback, delay) {
  var savedCallback = useRef();
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}

function defaultRender(value, decimals) {
  return Number(value).toFixed(decimals);
}

function NumberEasing(_ref) {
  var value = _ref.value,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 500 : _ref$speed,
      _ref$decimals = _ref.decimals,
      decimals = _ref$decimals === void 0 ? 0 : _ref$decimals,
      customFunctionRender = _ref.customFunctionRender,
      _ref$ease = _ref.ease,
      ease = _ref$ease === void 0 ? "quintInOut" : _ref$ease;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      renderValue = _useState2[0],
      renderValueSet = _useState2[1];

  var _useState3 = useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      lastTarget = _useState4[0],
      lastTargetSet = _useState4[1];

  var _useState5 = useState(new Date().getTime()),
      _useState6 = _slicedToArray(_useState5, 2),
      lastUpdateTime = _useState6[0],
      lastUpdateTimeSet = _useState6[1];

  useEffect(function () {
    lastUpdateTimeSet(new Date().getTime() - 16);
    lastTargetSet(renderValue);
  }, [value]);
  useInterval(function () {
    var currentTime = new Date().getTime();
    var absoluteProgress = (currentTime - lastUpdateTime) / speed;

    if (absoluteProgress >= 1) {
      renderValueSet(value);
    } else {
      var easedProgress = Eases[ease](absoluteProgress);
      renderValueSet(lastTarget + (value - lastTarget) * easedProgress);
    }
  }, 16);
  var functionRender = customFunctionRender || defaultRender;
  return React.createElement(React.Fragment, {}, [functionRender(renderValue, decimals)]);
}

export default NumberEasing;